import React, { Component } from 'react';

//Images
import Molecule from '../../../images/icon-molecule.png';

//Components
import Image from '../atoms/Image';
import PageTitle from '../molecules/PageTitle';
import PageTitle2 from '../molecules/PageTitle2';
import PageTitleSave from '../molecules/PageTitleSave';
import TextAnchorIcon from '../molecules/TextAnchorIcon';
import LabeledTextfield from '../molecules/LabeledTextfield';
import LabeledTextarea from '../molecules/LabeledTextarea';
import LabeledSelect from '../molecules/LabeledSelect';
import BotBox from '../molecules/BotBox';
import ItemBlock from '../molecules/ItemBlock/ItemBlock';
import SubjectBlock from '../molecules/SubjectBlock';
import DashboardPanelMenu from '../molecules/DashboardPanelMenu';
import SubjectTitle from '../molecules/SubjectTitle';
import DashboardWordBuilder from '../molecules/DashboardWordBuilder';
import BotAnswer from '../molecules/BotAnswer';
import SectionDivider from '../molecules/SectionDivider';

class Molecules extends Component {
	render() {
		return (
			<div className="styleguide">
				<div className="container">
					<div className="styleguide__section">
						<div className="styleguide__header">
							<Image classType="atomicDesign_headerImage" src={Molecule} alt="Atoms" />
							<h1 className="textHeadingOne color-black">Organisms</h1>
						</div>

						<h3 className="textHeadingThree">Labeled textfield</h3>

						<LabeledTextfield
							formGroupClassType="class"
							labelFor="Value"
							labelText="Value"
							labelId="Value"
							textfieldClassType="Value"
							textfieldId="Value"
							textfieldPlaceholder="Value"
							textfieldName="Value"
							textfieldForm="Value"
							textfieldOnChange="Value"
							errorMessageClassType="Value"
							errorMessageText="error"
						/>

						<h3 className="textHeadingThree subChapter" id="labeledTextfieldError">Labeled textfield error</h3>

						<LabeledTextfield
							formGroupClassType="form__group--error"
							labelFor="Value"
							labelText="Value"
							labelId="Value"
							textfieldClassType="class"
							textfieldId="Value"
							textfieldPlaceholder="Value"
							textfieldName="Value"
							textfieldForm="Value"
							textfieldOnChange="Value"
							errorMessageClassType="Value"
							errorMessageText="error"
						/>

						<h3 className="textHeadingThree subChapter" id="labeledTextfield">Labeled textarea</h3>

						<LabeledTextarea
							formGroupClassType="" labelFor="Value" labelText="Value" labelId="Value" textareaClassType="Value" textareaId="Value" textareaPlaceholder="Value" textareaName="Value" textareaForm="Value" textareaOnChange="Value" errorMessageClassType="Value" errorMessageText="error" />

						<h3 className="textHeadingThree subChapter" id="labeledtextareaError">Labeled textarea error</h3>

						<LabeledTextarea formGroupClassType="form__group--error" labelFor="Value" labelText="Value" labelId="Value" textareaClassType="" textareaId="Value" textareaPlaceholder="Value" textareaName="Value" textareaForm="Value" textareaOnChange="Value" errorMessageClassType="Value" errorMessageText="error" />



						<h3 className="textHeadingThree">Labeled select</h3>

						<LabeledSelect
							formGroupClassType=""
							labelFor="Value"
							labelText="Value"
							labelId="Value"
							selectClassType="Value"
							selectId="Value"
							selectName="Value"
							selectChildren="test"
							selectRequired="required"
							errorMessageClassType="Value"
							errorMessageText="error"

						/>

						<h3 className="textHeadingThree">Labeled select error</h3>

						<LabeledSelect
							formGroupClassType="form__group--error"
							labelFor="Value"
							labelText="Value"
							labelId="Value"
							selectClassType="Value"
							selectId="Value"
							selectName="Value"
							selectChildren="test"
							selectRequired="required"
							errorMessageClassType="Value"
							errorMessageText="error"

						/>


						<h3 className="textHeadingThree subChapter" id="botBox">Bot box</h3>
						<BotBox TextHeadingThree="Helena" href="#clicked" labelText="on" />

						<h3 className="textHeadingThree subChapter" id="itemBlock">Item block</h3>
						<ItemBlock classTypeIcon="fa-folder" text="Helena" buttonText="Link to facebook" />

						<h3 className="textHeadingThree subChapter" id="itemBlock">Item block(loading)</h3>
						<ItemBlock classTypeWrapper="itemBlock--loading" classTypeIcon="fa-folder" text="Helena" buttonText="Link to facebook" />

						<h3 className="textHeadingThree subChapter" id="itemBlockActive">Item block (active)</h3>
						<ItemBlock classTypeIcon="fa-folder" text="Helena" buttonText="Active" classTypeWrapper="itemBlock--active" classTypeButton="btn--success" iconRight="fa-check" />


						<h3 className="textHeadingThree subChapter" id="dashboardHeader">Sidebar Menu</h3>
						<TextAnchorIcon textAnchor="Link to facebook" icon="fa-check" href="#clicked" />

						<h3 className="textHeadingThree subChapter" id="dashboardHeader">Page title</h3>
						<PageTitle pageTitle="Page title" />

						
						<h3 className="textHeadingThree subChapter" id="dashboardHeader">Page title 2 (With save button)</h3>
						<PageTitleSave heading="Test" buttonText="Test" />


						<h3 className="textHeadingThree subChapter" id="dashboardHeader">Page title 2 (Without save button)</h3>
						<PageTitle2 heading="Test"/>
						<h3 className="textHeadingThree subChapter" id="dashboardHeader">DashboardHeader</h3>


						<DashboardPanelMenu text="Lorem ipsum" href="#clicked" />
						<SubjectBlock subject="Welcome" href="#clicked" />

						<h3 className="textHeadingThree subChapter">Dashboard word builder</h3>
						<DashboardWordBuilder placeholder="text" inputWordsClassType="Value" id="Value" name="Value" form="Value" textareaOnChange="Value" />

						<h3 className="textHeadingThree subChapter">Bot answer</h3>
						<BotAnswer placeholder="text" answerNumber="1" />

						<h3 className="textHeadingThree subChapter">Subject title</h3>
						<SubjectTitle subjectTitle="Welcome" buttonText="Save" />


						<h3 className="textHeadingThree subChapter">Section divider</h3>
						<SectionDivider heading="Welcome"/>

					</div>
				</div>
			</div>
		)
	}
}

export default Molecules;


// WEBPACK FOOTER //
// ./src/redux/components/templates/Molecules.jsx